import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CustomerLogos } from '../components/CustomerLogos';
import { FeaturesSection } from '../components/FeaturesSection';
import { VCLogos } from '../components/VCLogos';
import { CTABanner } from '../components/CTABanner';
export function HomePage() {
  return <>
      <HeroSection data-id="element-640" data-mp="3kreg0kbcaer0" />
      <CustomerLogos data-id="element-641" data-mp="3ko0gdju28jn9" />
      <FeaturesSection data-id="element-642" data-mp="2x0ikpd7od1f0" />
      <VCLogos data-id="element-643" data-mp="2wzplqyeyjg7f" />
      <CTABanner data-id="element-644" data-mp="2x1k4c62raw8c" />
    </>;
}